module.exports = __webpack_public_path__ + "img/icon-oilsprays.75306542.svg";